/*
 * Copyright (c) 2023-2025 Yesan SAS
 * All rights reserved
 *
 * The present software is the confidential and proprietary information of
 * Yesan SAS. You shall not disclose the present software and shall
 * use it only in accordance with the terms of the license agreement you
 * entered into with Yesan SAS. This software may be subject to
 * export or import laws in certain countries.
 */
/**
 * Translation
 */
export const translation = {
  "NotFound": "404 - Halaman Tidak Ditemukan",
  "ComingSoon": "Segera hadir",
  "YesanPersonalFinance": "Yesan, Keuangan Pribadi",
  "Yesan": "Yesan",
  "PersonalFinance": "Keuangan Pribadi",
  "YesanDownload": "Unduh Yesan",
  "ThisWebsiteUsesCookies": "Kami menggunakan cookie untuk mengumpulkan dan menganalisis informasi tentang kinerja dan penggunaan situs kami, serta menyediakan fitur media sosial. Dengan melanjutkan, Anda setuju dengan",
  "IGotIt": "OK",
  "BecomeFinanciallyFree": "Menjadi Bebas Finansial",
  "inStepsAndActions": "dalam 8 langkah dan 3 tindakan.",
  "TrackPlanAnalyze": "Lacak. Rencanakan. Menganalisis.",
  "FTrack": "1. Lacak",
  "FPlan": "2. Merencanakan",
  "FAnalyze": "3. Analisis",
  "Features": "Fitur",
  "FeaturesSubHeading": "Pemula murni, sudah melek finansial, ini adalah aplikasi yang Anda butuhkan untuk bebas finansial.",
  "ManageAccounts": "Kelola Akun",
  "CashLiquidFixedAssetsLiabilities": "Kas, Likuid, Aset Tetap & Kewajiban.",
  "TrackTransactions": "Melacak Transaksi",
  "IncomesExpensesTransferInvestments": "Pemasukan, Pengeluaran, Transfer, Investasi.",
  "ImportExport": "Impor / Ekspor",
  "YourDataAlwaysAccessible": "Data Anda selalu dapat diakses.",
  "PlanYourFreedom": "Rencanakan kebebasan Anda",
  "StepsAwayFromFI": "8 langkah lagi menuju Kemerdekaan Finansial.",
  "BudgetsAndGoals": "Anggaran & Tujuan",
  "CheckYourProgressAndAchieve": "Cek perkembangan Anda dan raih tujuan keuangan Anda.",
  "DashboardAndAnalytics": "Dasbor & Analisis",
  "ReviewLearnOptimizeWith": "Tinjau, Pelajari, Optimalkan dengan Grafik, Wawasan, Alat.",
  "Security": "Keamanan",
  "MilitaryGradeEncryption": "Enkripsi tingkat militer, dukungan biometri, data yang tersimpan di perangkat Anda.",
  "OfflineMode": "Mode offline",
  "YourDataAlwaysAccessibleAndModif": "Data Anda selalu dapat diakses dan dimodifikasi.",
  "Track": "Lacak",
  "Income": "Pendapatan",
  "Expense": "Pengeluaran",
  "Transfer": "Transfer",
  "transactionsAndManageAccounts": "transaksi & kelola berbagai Rekening:",
  "checkings": "Giro",
  "savings": "Tabungan",
  "realEstate": "Real Estat",
  "stocks": "Pasar saham",
  "bonds": "Obligasi",
  "crypto": "Kripto",
  "notes": "Uang kertas, Dompet Tunai",
  "envelopes": "Amplop",
  "privateEquity": "Ekuitas Swasta",
  "metal": "Logam",
  "retirement": "Pensiun",
  "lifeInsurance": "Asuransi Jiwa",
  "intellectualProperty": "Kekayaan Intelektual",
  "otherLiquidAsset": "Aset Likuid Lainnya",
  "otherFixedAsset": "Aset Tetap Lainnya",
  "mortgage": "Hipotek",
  "loan": "Kredit Konsumsi",
  "creditCard": "Kartu Kredit",
  "otherLiability": "Kewajiban Lainnya",
  "AccountsManagement": "Manajemen akun",
  "MultipleAccountsTypesAndGrouping": "Berbagai jenis akun dan pengelompokan",
  "LinkAccounts": "Tautkan Rekening dari institusi Anda (hanya tersedia di negara tertentu)",
  "SmartAccounts": "Akun pintar",
  "AddEditDeleteTransactions": "Tambah / Edit / Hapus transaksi",
  "TickVerifiedTransactions": "Centang transaksi yang telah diverifikasi",
  "CategorizeTransactions": "Mengkategorikan transaksi",
  "TagTransactions": "Menandai transaksi",
  "TrackKakeiboType": "Melacak jenis Kakeibo",
  "TrackInvestments": "Melacak Investasi (hanya tersedia di negara tertentu)",
  "ImportFromCSVFile": "Mengimpor transaksi secara penuh atau bertahap dari file CSV",
  "ExportToCSVFile": "Ekspor transaksi ke file CSV",
  "stepsTowardsFIPlanBudgetingReachGoals": "8 langkah menuju rencana Kemerdekaan Finansial, penganggaran terperinci, mencapai tujuan keuangan Anda lebih cepat.",
  "levelsTowardsFI": "8 tingkat menuju Kemerdekaan Finansial",
  "EstablishBudgetsPer": "Tetapkan Anggaran per",
  "account": "akun",
  "accountType": "jenis akun",
  "KakeiboType": "Jenis Kakeibo",
  "category": "kategori",
  "tag": "tag",
  "label": "label",
  "TrackBudgetsPerFrequency": "Melacak anggaran per frekuensi",
  "CreateGoalsOnSpendingBalanceCashFlowActions": "Buat Sasaran untuk pengeluaran, saldo, arus kas, tindakan",
  "TrackGoalsProgress": "Lacak kemajuan Sasaran",
  "ReviewLearnOptimizeWithReportsCharts": "Tinjau, Pelajari, Optimalkan dengan Laporan, Grafik, Tren, Wawasan, Alat.",
  "Dashboard": "Dasbor",
  "FSNetWorth": "Laporan Keuangan: Kekayaan Bersih",
  "FSPnL": "Laporan Keuangan: Laporan Laba Rugi / Laba Rugi",
  "FSBalanceSheetAssetsLiabilities": "Laporan Keuangan: Neraca, Aset, Kewajiban",
  "FSCashFlow": "Laporan Keuangan: Laporan Arus Kas, Debit Kredit, Arus",
  "FSFlows": "Laporan Keuangan: Arus",
  "FSRatios": "Laporan Keuangan: Rasio",
  "TrendsMonthEnd": "Tren Akhir Bulan: Pendapatan & Pengeluaran, Arus Kas",
  "TrendsPerformance": "Tren kinerja: YoY, MoM, WoW",
  "IncomeTrendsPer": "Tren pendapatan per",
  "SpendingTrendsPer": "Tren pengeluaran per",
  "RecurringItemsIE": "Pos-pos yang berulang: Pendapatan & Pengeluaran",
  "DebtProgressTrends": "Tren perkembangan utang",
  "KakeiboMTDReviewTrends": "Kakeibo Ulasan MTD, bulan lalu, tren",
  "FIWCLE": "Kemandirian Finansial: Bagan Dinding, Pengeluaran berdasarkan Energi Kehidupan",
  "DebtPaydownSnowballAvalanche": "Pelunasan Utang: Bola Salju, Longsoran Salju",
  "FullyCustomizableAnalyticsRange": "Rentang waktu analisis yang dapat disesuaikan sepenuhnya",
  "ContactUs": "Hubungi kami",
  "Privacy": "Privasi",
  "Terms": "Ketentuan",
  "About": "Tentang",
  "IAgreeToThe": "Saya setuju dengan",
  "AndThe": "dan",
  "PrivacyPolicy": "Kebijakan Privasi",
  "TermsOfUse": "Ketentuan Penggunaan",

  "DigitalSoftwareExperienceTagline": "Pengalaman perangkat lunak digital untuk dunia modern",
  "DigitalExperience": "Pengalaman Digital",
  "SoftwareForTheModernWorld": "Perangkat lunak untuk dunia modern",
  "MobileApplications": "Aplikasi Seluler",
  "forConnectedAndOfflineHumans": "untuk manusia yang terhubung dan offline",
  "CloudSaaS": "Cloud SaaS",
  "ResponsiveAndWebServices": "Layanan responsif dan Web",
  "PersonalFinanceServices": "Layanan Keuangan Pribadi",
  "YS_p1": "Yesan adalah perusahaan perangkat lunak dinamis yang berspesialisasi dalam pengembangan aplikasi seluler mutakhir yang dirancang khusus untuk konsumen. Dengan pemahaman yang mendalam tentang kebutuhan dan preferensi yang terus berkembang dari para pengguna yang melek teknologi saat ini, Yesan berdedikasi untuk menciptakan pengalaman seluler yang intuitif, menarik, dan kaya fitur yang memperkaya kehidupan para penggunanya.",
  "YS_p2": "Inti dari misi Yesan adalah komitmen tanpa henti terhadap inovasi dan kreativitas, setiap produk dibuat dengan cermat untuk memberikan fungsionalitas tanpa batas dan pengalaman pengguna yang luar biasa.",
  "PersonalFinanceApplication": "Aplikasi Keuangan Pribadi",
  "YPF_p1": "Yesan, Personal Finance adalah aplikasi mobile keuangan pribadi mutakhir yang dirancang untuk memberdayakan pengguna dengan alat manajemen keuangan yang komprehensif yang dapat diakses dengan mudah di ujung jari mereka. Dengan antarmuka yang ramping dan intuitif, Yesan, Personal Finance menawarkan pendekatan holistik untuk mengelola keuangan, melayani pengguna dari semua tingkat literasi keuangan.",
  "YPF_p2": "Fitur-fitur utama termasuk pelacakan anggaran, kategorisasi pengeluaran, dan pemantauan transaksi secara real-time, yang memungkinkan pengguna untuk mendapatkan wawasan tentang kebiasaan pengeluaran mereka dengan mudah. Aplikasi ini juga menawarkan opsi penganggaran yang dapat disesuaikan, memungkinkan pengguna untuk menetapkan tujuan keuangan dan melacak kemajuan mereka dari waktu ke waktu.",
  "YPF_p3": "Selain itu, Yesan, Personal Finance memprioritaskan keamanan, dengan menggunakan protokol enkripsi yang canggih untuk melindungi informasi keuangan pengguna yang sensitif. Dengan langkah-langkah keamanan setingkat bank, pengguna dapat dengan percaya diri menautkan akun mereka dan menyinkronkan transaksi tanpa mengorbankan privasi.",
  "YPF_p4": "Yesan, Personal Finance melampaui penganggaran dasar dengan menawarkan analisis mendalam dan rekomendasi yang dipersonalisasi untuk mengoptimalkan keputusan keuangan. Baik itu mengidentifikasi peluang menabung potensial, memantau portofolio investasi, atau mengelola strategi pembayaran utang, aplikasi ini memberikan wawasan khusus untuk membantu pengguna mencapai tujuan keuangan mereka.",
  "Discover": "Temukan",
  "Firstname": "Nama depan",
  "Lastname": "Nama belakang",
  "Company":"Perusahaan",
  "Subject": "Subjek",
  "Email": "Email",
  "Message": "Pesan",
  "ThankYouForContactingUs": "Terima kasih telah menghubungi kami",
  "ValidFirstnameRequired": "Nama depan yang valid harus diisi.",
  "ValidLastnameRequired": "Nama belakang yang valid harus diisi.",
  "ValidEmailAddressRequired": "Masukkan alamat email yang valid.",
  "ValidSubjectRequired": "Pilih subjek yang valid.",
  "ValidMessageRequired": "Silakan masukkan pesan yang valid.",
  "UnableToSendTheFormPleaseRetryLater": "Tidak dapat mengirim formulir, silakan coba lagi nanti.",
  "Information": "Informasi",
  "Sales":"Penjualan",
  "Support": "Dukungan",
  "Press": "Tekan",
  "Partnership": "Kemitraan",
  "Other": "Lainnya",
  "Blog":"Blog",

  "Accept":"Menerima",
  "Decline":"Menolak",

  "WorklogCalendar":"Kalender Worklog untuk Jira",

  "DirectlyAccessibleInProjectApps":"Dapat diakses langsung di aplikasi proyek",
  "VisualizeWhereYouSpentYourTime":"Memvisualisasikan di mana Anda menghabiskan waktu Anda",
  "AllYourWorklogsInACalendar":"Semua catatan kerja Anda dalam sebuah kalender",
  "MonthSummary":"Ringkasan bulan",
  "CheckIfYouForgotToLogTime":"Periksa apakah Anda lupa mencatat waktu.",
  "DirectlyAccessTheIssuesAndUpdateTime":"Mengakses masalah dan memperbarui waktu secara langsung",
  "DirectlyAccessTheIssuesAndUpdateTimeDescription":"Klik pada item catatan kerja untuk mengakses masalah secara langsung dan mengedit waktu yang dilacak",
  "AlsoAvailableInDarkMode":"Juga tersedia dalam mode gelap",
  "DirectlyLogWorkOnTheCalendarVisually":"Mencatat pekerjaan secara langsung di kalender secara visual",
  "ClickOnTheCalendarToCreateNewWorklog":"Klik pada kalender untuk membuat catatan kerja baru",

  "AppsForAtlassian":"Aplikasi untuk Atlassian",
  "YCL_p1":"Visualisasikan semua worklog Anda di kalender dengan tampilan bulan, minggu, minggu kerja, hari.",
  "YCL_p2":"Catat pekerjaan langsung dari kalender dengan memilih slot waktu secara visual.",
  "YCL_p3":"Identifikasi jika Anda lupa melacak waktu untuk lembar waktu Anda.",
  "YCL_p4":"Tersedia dalam bahasa Anda: Bahasa Inggris (Inggris), Bahasa Inggris (AS), Bahasa Mandarin (Sederhana), Bahasa Mandarin (Tradisional), Ceko, Denmark, Belanda, Estonia, Finlandia, Prancis, Jerman, Hungaria, Islandia, Italia, Jepang, Korea, Norwegia, Polandia, Portugis (Brasil), Portugis (Portugal), Rusia, Spanyol, Swedia, Turki.",

  "Kakeibo":"Kakeibo",
  "Genea":"Genea",
  "FinancialPortfolio":"Portofolio Keuangan untuk Jira",
  "BringRealFinancialPortfolio":"Hadirkan pengelolaan portofolio keuangan yang sesungguhnya ke Jira. Lacak anggaran, CapEx/OpEx, dan biaya proyek di satu tempat.",
  "YFPAboutQ":"Berapa sebenarnya biaya yang harus kami keluarkan untuk proyek-proyek Jira kami?",
  "YFPAbout":"Portofolio Keuangan untuk Jira\nPara pemimpin keuangan dan PMO kesulitan menjawab pertanyaan sederhana:\nBerapa sebenarnya biaya proyek Jira kita?\nJira melacak pekerjaan.\nBagian keuangan melacak anggaran.\nAplikasi ini akhirnya menghubungkan keduanya.\n\nPortofolio Keuangan mengubah Jira menjadi platform PPM + perencanaan keuangan yang ringan — tanpa perlu alat perusahaan yang mahal.",
  "YFPPorfolioQ":"Anggaran & Pelacakan Portofolio",
  "YFPPorfolioP":"Buat portofolio yang mencakup beberapa proyek Jira dan tentukan: Jumlah anggaran, Mata uang, Rentang tanggal, Proyek yang disertakan, tim. Lacak biaya aktual secara otomatis saat pekerjaan berlangsung di Jira.",
  "YFPPorfolioListQ":"Portofolio",
  "YFPPorfolioListP":"Buat portofolio keuangan yang menggabungkan beberapa proyek Jira dan lihat secara instan: Perbandingan Anggaran vs Biaya Aktual, Laju Pengeluaran Proyek secara Real-time, Rincian CapEx vs OpEx, Biaya per masalah dan proyek, Laporan keuangan yang dapat diekspor. Semua didukung langsung oleh catatan kerja Jira.",
  "CostQ":"Perhitungan Biaya Otomatis",
  "CostP":"Ubah pelacakan waktu menjadi data keuangan nyata. Aplikasi ini: Membaca catatan kerja Jira, Menerapkan tarif per jam, Menghitung biaya proyek aktual setiap hari. Tanpa spreadsheet. Tanpa pekerjaan manual.",
  "RatesQ":"Tarif",
  "RatesP":"Tetapkan tarif per jam per proyek, tim, atau secara global",
  "ReportQ":"Pelaporan Keuangan CSV",
  "ReportP":"Ekspor data keuangan portofolio dalam hitungan detik. Sangat cocok untuk: Tim keuangan, pelaporan CFO, perencanaan anggaran, dukungan audit",
  "SettingsQ":"Klasifikasi CapEx vs OpEx",
  "SettingsP":"Mendukung persyaratan akuntansi dan audit. Klasifikasikan pekerjaan menjadi: Pengembangan yang dapat dikapitalisasi (CapEx), Pekerjaan operasional (OpEx). Buat laporan yang dapat diekspor dan siap untuk tim keuangan."
};

export const documents = {
};
